<template>
    <b-modal v-model="localIsModalVisible" :title="modalTitle" @hide="resetModal">
        <form @submit.prevent="createStatus">
            <b-form-group label="Name" label-for="status-name-input" label-class="font-weight-bold">
                <b-form-input
                    id="status-name-input"
                    v-model="newStatusName"
                    type="text"
                    :placeholder="inputPlaceholder"
                    required
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Color" label-for="status-color-input" label-class="font-weight-bold">
                <b-form-input
                    id="status-color-input"
                    v-model="newStatusColor"
                    type="color"
                ></b-form-input>
            </b-form-group>
        </form>
        <template v-slot:modal-footer>
            <b-button variant="outline" @click="resetModal">Cancel</b-button>
            <b-button variant="primary" :disabled="creating" @click="createStatus">
                <loading v-if="creating"></loading>
                <span v-else>Create</span>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loading from "./Loading.vue";
import NotificationPop from "../mixins/NotificationPop";

export default {
    mixins: [NotificationPop],
    components: {
        Loading
    },
    props: {
        isModalVisible: {
            type: Boolean,
            default: false
        },
        tabId: {
            type: Number,
            required: true
        },
        afterStatusId: {
            type: Number,
            default: null
        },
        modalTitle: {
            type: String,
            default: "Create status"
        },
        inputPlaceholder: {
            type: String,
            default: "In Progress, Completed, Planned, ..."
        }
    },
    data() {
        return {
            newStatusName: '',
            newStatusColor: '#000000',
            creating: false,
            localIsModalVisible: this.isModalVisible
        };
    },
    watch: {
        isModalVisible(value) {
            this.localIsModalVisible = value;
        },
        localIsModalVisible(value) {
            this.$emit('update:isModalVisible', value);
        }
    },
    methods: {
        resetModal() {
            this.localIsModalVisible = false;
            this.newStatusName = '';
            this.newStatusColor = '#000000';
            this.creating = false;
            this.$emit('hide');
        },
        createStatus() {
            if (!this.newStatusName.trim()) {
                alert('Please enter a status name.');
                return;
            }

            const data = {
                name: this.newStatusName,
                color: this.newStatusColor,
                tab_id: this.tabId,
                after_id: this.afterStatusId
            };

            this.creating = true;
            this.$http.post('/http_api/statuses', data)
                .then(response => {
                    this.$emit('status-created', response.data.data);
                    this.popNotification('Status added 🙌', 'success');
                    this.resetModal();
                })
                .catch(error => {
                    console.error(error);
                    this.creating = false;
                    this.popNotification('Something went wrong on our side. Could not create status. Please try again or contact support.', 'danger');
                });
        }
    }
};
</script>